import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../components/HomePage.vue'
import ContactPage from '../components/ContactPage'
import NoticePage from '../components/NoticePage'
import TeamPage from '../components/TeamPage'
import ServicePage from '../components/ServicePage'
import AboutPage from '../components/AboutPage'
import SlidesPage from '../components/SlidesPage'

const routes = [
  
  {
    path: '/TeamPage',
    name: 'TeamPage',
    component: TeamPage
  },

  {
    path: '/ServicePage',
    name: 'ServicePage',
    component: ServicePage
  },
  {
    path: '/AboutPage',
    name: 'AboutPage',
    component: AboutPage
  },
  {
    path: '/SlidesPage',
    name: 'SlidesPage',
    component: SlidesPage
  },
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
 
  {
    path: '/notice',
    name: 'notice',
    component: NoticePage
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage
  }
]

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior (to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
   
      }
    }
  },
  routes,

})
export default router